const BASE =
  "https://docs.google.com/spreadsheets/d/1ji0IFyXd9BxwXxgSomBZJZGdGHlmBsDnVsjF5_q_t9g/gviz/tq?tqx=out:csv&sheet=";
const BASE_BY_GID =
  "https://docs.google.com/spreadsheets/d/1ji0IFyXd9BxwXxgSomBZJZGdGHlmBsDnVsjF5_q_t9g/gviz/tq?tqx=out:csv&gid=";

export const SHEETS = {
  // location
  zipCode: BASE + "zipCode",

  // home info
  homeType: BASE + "homeType",
  squareFeet: BASE + "squareFeet",
  stories: BASE + "stories",
  yearBuilt: BASE + "yearBuilt",
  ownership: BASE + "ownership",

  // current system
  currentFuelType: BASE + "currentFuelType",
  currentACtonnage: BASE + "currentACtonnage",
  systemlocation: BASE + "systemlocation",
  currentSystemAge: BASE + "currentSystemAge",

  // preferences
  desiredSystemType: BASE + "desiredSystemtype", // ⚠️ casing fix
  desiredFuelType: BASE + "desiredFuelType",
  miniSplitRooms: BASE + "miniSplitRooms",

  // pricing
  pricing: BASE + "Data%20Table",

  // result assets
  productImages: BASE_BY_GID + "1659734622",

  // optional global copy overrides
  content: BASE + "Content",
};
